









































































































import {Component} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {PushDeviceItem} from "@/store/push/devices/types";
import ImportWhiteList from "@/components/Settings/WhiteLists/ImportWhiteList.vue";
import {notifyDelete, notifyError} from "@/utils/notify-helper";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";
import PushDeviceFilter from "@/components/Push/Devices/PushDeviceFilter.vue";
import {dateFilter} from "@/utils/date-util";

@Component({
  components: {PushDeviceFilter, ImportWhiteList, ScrollButton},
  filters: {dateFilter}
})
export default class PushDevices extends BaseItemsPage<PushDeviceItem> {
  @Getter("pushDevices") devices!: PushDeviceItem[];
  @Action("deletePushDevices") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private is_show_filter = true;
  private ids: (number | undefined)[] = [];
  private logObject: ActionLog = {};
  currentSort = "id";
  currentSortOrder = "desc";

  tableFields = this.tableFieldsDefault;

  get tableFieldsDefault() {
    return ['client_id', 'create_date',
      'device_id', 'os', 'os_version',
      'application', 'sdk_version',
      'app_version', 'vendor', 'detail'
    ];
  }

  getData(): PushDeviceItem[] {
    return this.devices;
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete(this.$t('dialog.deletion_in_one_minute').toString());
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Devices",
          addititional_info: getTranslatedParams({id: this.$route.params.id, number: this.ids.length})
        }
        const { filter } = this.$refs.filter as any;
        await this.actionDelete({ids: this.ids, filter});
        await this.actionLog(this.logObject);
      } catch (error) {
        this.actionLog({...this.logObject, action_status: 'failed'});
        notifyError(error);
      }
    }
  }

  onSelect(items: PushDeviceItem[]): void {
    this.ids = items.filter(i => i.id !== null).map(i => i.id);
  }
}
